'use client';

import { useState } from 'react';
import { supabase } from '../lib/supabaseClient';

export default function FicheForm() {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [steps, setSteps] = useState(['']);
  const [relatedLinks, setRelatedLinks] = useState([{ label: '', href: '' }]);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { data: userData } = await supabase.auth.getUser();
    const user = userData?.user;
    if (!user) return setMessage('Vous devez être connecté.');

    const { error } = await supabase.from('fiches_pratiques').insert([
      {
        user_id: user.id,
        title,
        description,
        steps,
        related_links: relatedLinks,
      },
    ]);

    if (error) {
      console.error(error);
      setMessage('Erreur : ' + error.message);
    } else {
      setMessage('✅ Fiche ajoutée avec succès.');
      setTitle('');
      setDescription('');
      setSteps(['']);
      setRelatedLinks([{ label: '', href: '' }]);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="p-6 bg-white rounded-2xl shadow space-y-4 max-w-xl mx-auto">
      <h2 className="text-xl font-bold">Ajouter une fiche pratique</h2>

      <input
        type="text"
        placeholder="Titre"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        className="w-full p-2 border rounded"
        required
      />

      <textarea
        placeholder="Description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        className="w-full p-2 border rounded"
        required
      />

      <div>
        <label className="block font-medium mb-1">Étapes</label>
        {steps.map((step, idx) => (
          <input
            key={idx}
            type="text"
            value={step}
            onChange={(e) => {
              const newSteps = [...steps];
              newSteps[idx] = e.target.value;
              setSteps(newSteps);
            }}
            placeholder={`Étape ${idx + 1}`}
            className="w-full mb-2 p-2 border rounded"
          />
        ))}
        <button
          type="button"
          onClick={() => setSteps([...steps, ''])}
          className="text-blue-600 text-sm"
        >
          + Ajouter une étape
        </button>
      </div>

      <div>
        <label className="block font-medium mb-1">Liens utiles</label>
        {relatedLinks.map((link, idx) => (
          <div key={idx} className="flex gap-2 mb-2">
            <input
              type="text"
              placeholder="Label"
              value={link.label}
              onChange={(e) => {
                const updated = [...relatedLinks];
                updated[idx].label = e.target.value;
                setRelatedLinks(updated);
              }}
              className="w-1/2 p-2 border rounded"
            />
            <input
              type="url"
              placeholder="URL"
              value={link.href}
              onChange={(e) => {
                const updated = [...relatedLinks];
                updated[idx].href = e.target.value;
                setRelatedLinks(updated);
              }}
              className="w-1/2 p-2 border rounded"
            />
          </div>
        ))}
        <button
          type="button"
          onClick={() => setRelatedLinks([...relatedLinks, { label: '', href: '' }])}
          className="text-blue-600 text-sm"
        >
          + Ajouter un lien
        </button>
      </div>

      <button type="submit" className="bg-black text-white px-4 py-2 rounded">
        Ajouter la fiche
      </button>

      {message && <p className="mt-2 text-sm">{message}</p>}
    </form>
  );
}
